import { get } from "lodash";
import {
  INSURANCE_PLAN_RISKS,
  SUBSCRIPTION_TEMPLATES,
  TEMPLATE_TYPES,
} from "utils/constants";
import Templates from "./Templates";

const ACORIS_PROCESS_TEMPLATES = [
  TEMPLATE_TYPES.B2B_ACORIS,
  TEMPLATE_TYPES.B2C_ACORIS,
];

export const resolveSubscriptionTemplate = ({
  processTemplate,
  organizationTemplate,
  insurancePlanRisk,
} = {}) => {
  const isAcorisOrganization =
    SUBSCRIPTION_TEMPLATES[organizationTemplate] ===
    SUBSCRIPTION_TEMPLATES.ACORIS;
  if (
    ACORIS_PROCESS_TEMPLATES.includes(processTemplate) ||
    isAcorisOrganization
  ) {
    return Templates.Acoris;
  }
  const isMiltisOrganization =
    SUBSCRIPTION_TEMPLATES[organizationTemplate] ===
    SUBSCRIPTION_TEMPLATES.MILTIS;
  if (isMiltisOrganization) {
    if (insurancePlanRisk === INSURANCE_PLAN_RISKS.OBSEQUE) {
      return Templates.MiltisObseques;
    }
    return Templates.Miltis;
  }
  return get(
    Templates,
    SUBSCRIPTION_TEMPLATES[organizationTemplate],
    Templates.Health,
  );
};
